import React from "react";
import { useIntl } from "react-intl";

/*
    Cancel Icon
    props:
        - title: string, override the default title 'Calendar'
        - color: string, override the default color '#00549A' (bell blue)
*/

const CalendarIcon = (props) => {
    const intl = useIntl();
    return (
        <svg className={props.className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <title>{props.title || intl.locale == "en" ? "Calendar" : "Calendrier"}</title>
            <path
                d="M15.4866 3.75781V5.25781M15.4866 6.75781V5.25781M8.48658 3.75781V5.25781M8.48658 6.75781V5.25781M8.48658 5.25781H15.4866M8.48658 5.25781H5.25L5.25 17.0202H16.4866L18.7542 14.7037M15.4866 5.25781H18.7542V14.7037M5.25 20.2419H18.7542V14.7037"
                stroke={props.color || "#00549A"}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.6339 14.937C9.40386 14.937 8.62686 14.373 8.30286 13.245L9.32886 12.849C9.44286 13.251 9.60786 13.536 9.82386 13.704C10.0399 13.866 10.3099 13.947 10.6339 13.947C10.9759 13.947 11.2489 13.857 11.4529 13.677C11.6569 13.491 11.7589 13.233 11.7589 12.903C11.7589 12.585 11.6449 12.33 11.4169 12.138C11.1889 11.946 10.8649 11.85 10.4449 11.85H10.0039V10.923H10.4269C10.7449 10.917 10.9789 10.836 11.1289 10.68C11.2849 10.524 11.3629 10.332 11.3629 10.104C11.3629 9.88797 11.2969 9.71697 11.1649 9.59097C11.0329 9.45896 10.8499 9.39296 10.6159 9.39296C10.1479 9.39296 9.79986 9.65696 9.57186 10.185L8.63586 9.72596C8.80386 9.30596 9.06486 8.98796 9.41886 8.77196C9.77286 8.54996 10.1719 8.43896 10.6159 8.43896C11.1859 8.43896 11.6419 8.58596 11.9839 8.87997C12.3259 9.16796 12.4969 9.55496 12.4969 10.041C12.4969 10.545 12.2689 10.95 11.8129 11.256C12.5389 11.58 12.9019 12.126 12.9019 12.894C12.9019 13.488 12.6919 13.977 12.2719 14.361C11.8579 14.745 11.3119 14.937 10.6339 14.937Z"
                fill={props.color || "#00549A"}
            />
            <path
                d="M14.2351 14.856V9.86097L13.2721 10.644V9.39296L14.0731 8.73597C14.2891 8.55597 14.5051 8.46597 14.7211 8.46597C15.1171 8.46597 15.3151 8.66997 15.3151 9.07797V14.856H14.2351Z"
                fill={props.color || "#00549A"}
            />
        </svg>
    );
};

export default CalendarIcon;
